import useInView from '../hooks/useInView';
import { Link } from 'react-router-dom';
import BookCover from './book/BookCover';
import { useShopLang } from '../context/ShopLangContext.jsx';
import { useTranslation } from 'react-i18next';

const ComicBooks = () => {
  const { lang } = useShopLang();
  const { t } = useTranslation('common');

  const comicData = [
    { id: 1, image: '/assets/imgs/Home/Newest Comic Books/1.png', price: '$00.00' },
    { id: 2, image: '/assets/imgs/Home/Newest Comic Books/2.png', price: '$00.00' },
    { id: 3, image: '/assets/imgs/Home/Newest Comic Books/3.png', price: '$00.00' },
    { id: 4, image: '/assets/imgs/Home/Newest Comic Books/1.png', price: '$00.00' },
    { id: 5, image: '/assets/imgs/Home/Newest Comic Books/1.png', price: '$00.00' },
    { id: 6, image: '/assets/imgs/Home/Newest Comic Books/2.png', price: '$00.00' },
    { id: 7, image: '/assets/imgs/Home/Newest Comic Books/3.png', price: '$00.00' },
    { id: 8, image: '/assets/imgs/Home/Newest Comic Books/3.png', price: '$00.00' },
  ];

  const [ref, inView] = useInView({ threshold: 0.15 });

  return (
    <section ref={ref} className="bg-cream py-16 lg:py-20" id="shop">
      <div className="container mx-auto px-8 lg:px-16">
        {/* Section Title */}
        <div className={`text-center mb-12 transition-all duration-700 ease-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
          <h2 className="text-4xl lg:text-5xl font-bold text-text-dark mb-2">
            {t('home.comicBooks.title')}
          </h2>
          <p className="text-base font-medium text-text-dark">
            {t('home.comicBooks.featured')}
          </p>
        </div>
        {/* Comics Grid */}
        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 mb-12">
          {comicData.map((comic, i) => (
            <div
              key={comic.id}
              className={`group transition-all duration-700 ease-out ${inView ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6'}`}
              style={{ transitionDelay: `${100 + i * 120}ms` }}
            >
              <Link to="/product" className="block">
                <div className="bg-[#e8dcc8] border-2 border-text-dark rounded overflow-hidden aspect-[3/4] mb-3 transition-all duration-500 group-hover:-translate-y-2 group-hover:scale-105 group-hover:shadow-xl">
                  <BookCover image={'/assets/imgs/Shop/Without_text.png'} lang={lang} />
                </div>
              </Link>
              <div className="flex items-center justify-between mb-1">
                <h5 className="text-base font-medium text-text-dark">{t('home.comicBooks.itemTitle', { index: String(i + 1).padStart(2, '0') })}</h5>
                <div className="flex gap-0.5">
                  {[...Array(5)].map((_, i) => (
                    <svg key={i} xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="#ffcb36">
                      <path d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"/>
                    </svg>
                  ))}
                </div>
              </div>
              <p className="text-base font-bold text-price-red">{comic.price}</p>
            </div>
          ))}
        </div>

        {/* View More Button */}
        <div className="text-center">
          <Link to="../shop" className="inline-block bg-brown hover:bg-brown-dark text-cream px-10 py-3 rounded-md text-sm font-normal uppercase tracking-wide transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
            {t('home.viewMore')}
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ComicBooks;
